const TOP = 'top';
const BOTTOM = 'bottom';

export const DEFAULT_POSITION = TOP;
export const POSITIONS = [TOP, BOTTOM];
export const DEFAULT_TEST_ID = 'sticky';

export const SCROLL = 'scroll';
export const RESIZE = 'resize';

export const throttleTimeout = 30;
